import React, { useEffect, useState } from 'react';
import '../css/navBar.css';
import '../css/registro.css';
import { DashboardTable } from './DashboardTable';
import { useAdminUsers } from '../hooks/useAdminUsers';
import { AdminUserModals } from './AdminUserModals';
import { useCompaniesQuery } from '../hooks/useCompaniesQuery';
import { CompanyActions } from './CompanyActions';
import connectWebSocket from '../WebSocketClient';
import { useCollection } from '../hooks/useCollection';

export const ControlPanel = () => {
    const [maximized, setMaximized] = useState(null);
    const { companies, loading, updateCompany } = useCompaniesQuery("empresa/nuevosRegistros");
    //const { companies, loading, updateCompany } = useCompaniesQuery("empresa/todasLasEmpresas", { size: 100000 });
    // 🔥 Hook reutilizable
    const admin = useAdminUsers({ onUpdateCompany: updateCompany });

    const {
        items: notifications,
        loading: loadingNotifications,
        addItem: addNotification 
    } = useCollection('empresa/nuevasInscripciones');

    const selectedCompany = companies?.find(
        c => c.id === admin.idElemSeleccionado
    ) || admin.profilePlaceholder;

    const contentCompany = (elem) => {
        return (
            <>
                <div className='col-12 col-sm mb-3 mb-sm-0 nombreEventoMobile'>{elem.nombre}</div>

                <div className='col col-sm-4 text-end d-flex justify-content-center justify-content-sm-end'>
                    <CompanyActions
                        company={elem}
                        isLoading={admin.isLoading}
                        onApprove={(id) => admin.evaluarUsuario(id, true)}
                        onSelect={admin.setIdElemSeleccionado}
                    />
                </div>
            </>
        );
    };

    const contentInscription = (elem) => {
        return <div className='col'>{elem}</div>;
    };

    const contentEvent = (elem) => {
        return (
            <>
                <div className='col-12 col-sm mb-3 mb-sm-0 nombreEventoMobile'>{elem.nombre}</div>
                <div className='col col-sm-4 col-md-3 text-start text-sm-end'>{elem.fecha}</div>
            </>
        );
    };

    useEffect(() => {
        const clientInscription = connectWebSocket('inscripciones/nuevaInscripcion', (dato) => {
            addNotification(dato);
        }); 

        return () => {
            clientInscription?.deactivate?.(); 
        };
    }, []) 

    const isTopRowActive =
        maximized === 'empresas' || maximized === 'inscripciones';

    const isBottomRowActive = maximized === 'eventos';

    return (
        <>
            <div
                className={`pt-4 d-flex flex-column controlPanel h-100 ${maximized
                    ? 'gap-0 transition-table-control-panel'
                    : 'gap-4 transition-all-1s'
                    }`}
            >
                {/* FILA SUPERIOR */}
                <div
                    className={`row h-0  m-1  transition-all-1s flex-column flex-lg-row m-xs-0 ${isTopRowActive
                        ? 'gap-0 transition-table-control-panel'
                        : 'gap-4 transition-all-1s'
                        } ${isBottomRowActive ? 'flex-0 p-0' : 'flex-1'
                        }`}
                >
                    <DashboardTable
                        id="empresas"
                        row="top"
                        title="Nuevas Empresas"
                        elemNoEncontrado="empresas"
                        contenidoFilaTabla={contentCompany}
                        maximized={maximized}
                        setMaximized={setMaximized}
                        classNameTabla={`col h-100 ${maximized === 'eventos' || maximized === 'inscripciones' ? 'border-0' : ''}`}
                        elements={companies}
                        isLoading={loading}
                    />

                    <DashboardTable
                        id="inscripciones"
                        row="top"
                        title="Notificaciones" 
                        elemNoEncontrado="notificaciones"
                        contenidoFilaTabla={contentInscription}
                        maximized={maximized}
                        setMaximized={setMaximized}
                        classNameTabla={`col h-100 ${maximized === 'empresas' || maximized === 'eventos' ? 'border-0' : ''}`}
                        elements={notifications}
                        isLoading={loadingNotifications}
                    />
                </div>

                {/* FILA INFERIOR */}
                <div
                    className={`row h-0 transition-all-1s m-1 ${isTopRowActive ? 'flex-0 p-0' : 'flex-05 flex-lg-1'
                        } ${isBottomRowActive ? 'flex-1' : ''}`}
                >
                    <DashboardTable
                        id="eventos"
                        row="bottom"
                        title="Próximos eventos"
                        url="evento/eventosAFuturo"
                        elemNoEncontrado="eventos"
                        contenidoFilaTabla={contentEvent}
                        maximized={maximized}
                        setMaximized={setMaximized}
                        classNameTabla={`h-100 ${isTopRowActive ? 'border-0' : ''}`}
                    />
                </div>
            </div >

            {/* 🔥 MODALES REUTILIZABLES */}
            <AdminUserModals {...admin} perfil={selectedCompany} />
        </>
    );
};
